// @flow

import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import type { Toast, RemoveToastActionCreator } from '../../typings';
import type { State as GlobalState } from '../../rootReducer';
import { removeToast } from '../../../utils/actions';

import CustomToast from './CustomToast';

const ToastsContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 12px;
  left: 0;
  right: 0;
  padding-horizontal: 12px;
  align-items: center;
  background-color: transparent;
  overflow: hidden;
  z-index: 8;
`;

type Props = {
  toasts: Array<Toast>,
  deviceWidth: number,
  removeToast: RemoveToastActionCreator
};

function CustomToasts({ toasts, deviceWidth, removeToast }: Props) {
  function closeToast(toast: Toast) {
    removeToast(toast.id);
  }

  return (
    <ToastsContainer>
      {toasts.map(toast => (
        <CustomToast
          key={toast.id}
          deviceWidth={deviceWidth}
          toast={toast}
          closeCallback={() => closeToast(toast)}
        />
      ))}
    </ToastsContainer>
  );
}

type PropsFromState = {
  toasts: Array<Toast>
};
function mapStateToProps(state: GlobalState): PropsFromState {
  return {
    toasts: state.core.toasts
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        removeToast
      },
      dispatch
    )
  };
}

CustomToasts.propTypes = {
  toasts: PropTypes.array,
  removeToast: PropTypes.func,
  deviceWidth: PropTypes.number
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomToasts);
